// Extended mock/content data for sub-pages

export const pageImages = {
  about: 'https://images.unsplash.com/photo-1604352704611-cce8fe2a4e0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBza3lsaW5lfGVufDB8fHx8MTc4MzYzNTk3OXww&ixlib=rb-4.1.0&q=85',
  csr: 'https://images.unsplash.com/photo-1758599669327-83d310882929?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxjb21tdW5pdHklMjBzdXN0YWluYWJpbGl0eXxlbnwwfHx8fDE3ODM2MzU5Nzl8MA&ixlib=rb-4.1.0&q=85',
  team: 'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzgzNjM1OTc5fDA&ixlib=rb-4.1.0&q=85',
  blog: 'https://images.unsplash.com/photo-1484788984921-03950022c9ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGxhcHRvcHxlbnwwfHx8fDE3ODM2MzU5Nzl8MA&ixlib=rb-4.1.0&q=85',
};

export const values = [
  {
    title: 'Integrity',
    text: 'Doing what is right, even when no one is watching. Trust is our currency.',
  },
  {
    title: 'Innovation',
    text: 'Investing in R&D to stay ahead of dynamic market cycles and disruption.',
  },
  {
    title: 'Excellence',
    text: 'A relentless pursuit of quality across every vertical and every geography.',
  },
  {
    title: 'Sustainability',
    text: 'Long-term value creation for stakeholders, communities and the planet.',
  },
];

export const milestones = [
  { year: '1995', title: 'Foundation', text: 'Emerald incorporated as a boutique advisory firm.' },
  { year: '2003', title: 'International Alliances', text: 'First cross-border JV in Middle East precious metals corridor.' },
  { year: '2011', title: 'Capital Markets', text: 'Launch of primary & secondary market services desk.' },
  { year: '2018', title: 'Digital & Fintech', text: 'Expansion into digital assets and fintech infrastructure.' },
  { year: '2024', title: 'Global Conglomerate', text: '100+ partners across 4 continents and 10 verticals.' },
];

export const leaders = [];

export const csrPillars = [
  {
    title: 'Education',
    text: 'Scholarships and STEM programs for underserved communities across our operating regions.',
  },
  {
    title: 'Environment',
    text: 'Carbon-conscious operations, urban afforestation and clean-energy investments.',
  },
  {
    title: 'Health & Wellness',
    text: 'Preventive-care camps, mental-health support and access to essential medicines.',
  },
  {
    title: 'Livelihood',
    text: 'Skill-building and micro-enterprise support to lift families out of poverty.',
  },
];

export const serviceContent = {
  'bullion-trading': {
    title: 'Bullion Trading',
    eyebrow: 'Precious Metals',
    description:
      'Trusted global partner for physical gold, silver and platinum trading with secured vaulting, insured logistics and 24x7 execution.',
    image:
      'https://images.unsplash.com/photo-1610375461369-d613b564f4c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxnb2xkJTIwYnVsbGlvbnxlbnwwfHx8fDE3ODM2MzM4MzV8MA&ixlib=rb-4.1.0&q=85',
    highlights: [
      { title: 'LBMA Good Delivery', text: 'Access to LBMA good-delivery bars sourced from accredited refiners.' },
      { title: 'Secured Vaulting', text: 'Bonded, insured vaults in Zurich, Dubai, Singapore and Mumbai.' },
      { title: 'Global Logistics', text: 'Door-to-vault, vault-to-vault and cross-border settlement.' },
      { title: 'Price Discovery', text: 'Multi-venue live quotes, hedged execution and NDF structures.' },
    ],
  },
  'corporate-finance': {
    title: 'Corporate Finance',
    eyebrow: 'Advisory & Structuring',
    description:
      'Strategic advisory across mergers, acquisitions, debt syndication and structured funding solutions across mid-market and enterprise clients.',
    image:
      'https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3ODM2MzM4MzR8MA&ixlib=rb-4.1.0&q=85',
    highlights: [
      { title: 'M&A Advisory', text: 'Sell-side, buy-side and joint-venture structuring end-to-end.' },
      { title: 'Debt Syndication', text: 'Working capital, project finance and structured credit lines.' },
      { title: 'Equity Raising', text: 'Pre-IPO, private placements and strategic investor onboarding.' },
      { title: 'Restructuring', text: 'Turnaround, refinancing and balance-sheet optimization.' },
    ],
  },
  'market-services': {
    title: 'Primary & Secondary Market Services',
    eyebrow: 'Capital Markets',
    description:
      'Full-spectrum capital market execution across venture capital, SBICs and investment banking with a research-first mindset.',
    image:
      'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxzdG9jayUyMHRyYWRpbmd8ZW58MHx8fHwxNzgzNjMzODM1fDA&ixlib=rb-4.1.0&q=85',
    highlights: [
      { title: 'Venture Capital', text: 'Backing early-stage founders with capital, network and playbooks.' },
      { title: 'SBICs', text: 'Small-business investment vehicles supporting the mid-market.' },
      { title: 'Investment Banking', text: 'Origination, execution and after-market support for issuers.' },
      { title: 'Research', text: 'Independent thematic and macro research powering allocation.' },
    ],
  },
};

export const blogPosts = [
  {
    id: 'gold-cycle-2026',
    title: 'Reading the 2026 Gold Cycle: Signals from the Bullion Desk',
    excerpt:
      'Central-bank buying, dollar liquidity and jewellery demand are converging. Here is how our desk sees the next 12 months.',
    category: 'Bullion',
    author: 'Emerald Bullion Desk',
    date: 'Jul 6, 2026',
    image: 'https://images.unsplash.com/photo-1610375461369-d613b564f4c4?w=1000&q=80',
  },
  {
    id: 'oil-macro-view',
    title: 'Oil Macro View: WTI, Brent and the OPEC+ Balancing Act',
    excerpt:
      'Inventory data, geopolitics and refinery margins point to a wider trading range through the second half of 2026.',
    category: 'Energy',
    author: 'Emerald Commodities Research',
    date: 'Jun 28, 2026',
    image: 'https://images.unsplash.com/photo-1615767979327-1cd91ff3a5cf?w=1000&q=80',
  },
  {
    id: 'mid-market-ma',
    title: 'The Mid-Market M&A Playbook for a High-Rate Regime',
    excerpt:
      'Deal certainty, structured earnouts and secondary buyouts are back in vogue. What sellers need to know.',
    category: 'Corporate Finance',
    author: 'Emerald Corporate Finance',
    date: 'Jun 14, 2026',
    image: 'https://images.unsplash.com/photo-1638262052640-82e94d64664a?w=1000&q=80',
  },
  {
    id: 'venture-thesis-fintech',
    title: 'Our Venture Thesis: Fintech Infrastructure for Emerging Markets',
    excerpt:
      'Where we are investing across payments, banking-as-a-service and compliance rails.',
    category: 'Venture',
    author: 'Emerald Digital Assets',
    date: 'May 30, 2026',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1000&q=80',
  },
  {
    id: 'copper-supply',
    title: 'The Copper Supply Squeeze: A Structural Story',
    excerpt:
      'Electrification, grid upgrades and mine-side underinvestment are re-rating the red metal.',
    category: 'Commodities',
    author: 'Emerald Commodities Research',
    date: 'May 12, 2026',
    image: 'https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=1000&q=80',
  },
  {
    id: 'ipo-2026',
    title: 'IPO Windows in 2026: Timing, Pricing and Aftermarket',
    excerpt:
      'A practical guide for founders navigating a discerning primary market.',
    category: 'Capital Markets',
    author: 'Emerald Capital Markets',
    date: 'Apr 22, 2026',
    image: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=1000&q=80',
  },
];

export const contactInfo = {
  companyName: 'EMERALD CORPORATES LIMITED',
  companyNumber: '16120279',
  address: 'Office Gold, Building 7, Floor 5, 566 Chiswick High Road, Chiswick Business Park, London, United Kingdom, W4 5YG',
  emails: ['info@emeraldcorporates.com'],
};
